/* eslint-disable no-confusing-arrow */
import _ from 'lodash';
import { APP_CONFIG } from 'common/constants';

export const fileLink = data => {
	if (!data) {
		return null;
	}

	if (data.selected === 'file') {
		const fileUrl = _.get(data, 'file.url', '');
		if (fileUrl.split('/')[0] !== 'https:') {
			const CDN = `${APP_CONFIG.cdn.hostname}`;
			const path = _.get(data, 'file.url', '');
			return `${CDN}/${path}`;
		}
		return _.get(data, 'file.url', '');
	}
	return _.get(data, 'remoteURL', '');

	// return data.selected === 'file' ? _.get(data, 'file.url', '') : _.get(data, 'remoteURL', '');
};
